import { Component, OnInit, ViewChild, ElementRef, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { VendorService } from '../../../services/vendor.service';
import { PrintService } from '../../../services/print.service';
import { GlobalSearchService } from '../../../services/globalsearchservice.service';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { buildDashboardThemeVars } from '../../../shared/dashboard-widget-theme';

@Component({
	selector: 'app-vendordash-payments',
	templateUrl: './vendordash-payments.component.html',
	styleUrls: ['./vendordash-payments.component.scss'],
	animations: [
	  trigger('flipState', [
		  state('active', style({
			  transform: 'rotate3d(0, 1, 0, 179deg)',
		  })),
		  state('inactive', style({
			  transform: 'rotateY(0)'
		  })),
		  transition('active => inactive', animate('500ms ease-out')),
		  transition('inactive => active', animate('500ms ease-in')),
	  ]),
	]
})
export class VendordashPaymentsComponent implements OnInit {
	flip = 'inactive';
	@Output() viewData = new EventEmitter<any>();

	recentPayments: any[] = [];
	paymentsLoaded = false;
	viewing: any = false;
	title: any = '';
	exporting = false;
	@ViewChild('print_table') printtable: ElementRef;

	get themeVars(): Record<string, string> {
		return buildDashboardThemeVars('cw', 'rose');
	}

	constructor(
		private vendorService: VendorService,
		private router: Router,
		private printService: PrintService,
		private globalSearchService: GlobalSearchService
	) {}

	ngOnInit(): void {
		this.vendorService.getDashBoard().subscribe((results: any) => {
			this.recentPayments = results?.recentPayments || [];
			this.paymentsLoaded = true;
		});
	}

	toggleFlip(data: any, title: string) {
		if (!data) {
			this.flip = 'inactive';
		} else {
			this.flip = (this.flip == 'active') ? 'inactive' : 'active';
		}

		if (this.flip == 'active') {
			this.viewing = data;
			this.title = title;
			this.viewData.emit({ data: data, title: 'Recent Payments' });
		} else {
			this.viewing = false;
			this.viewData.emit(false);
		}
	}

	navigateToVendor(supplierid: string) {
		if (supplierid) {
			this.router.navigate(['/vendors', supplierid]);
		}
	}

	exportPdf() {
		this.exporting = true;
		const encoded: string = this.globalSearchService.base64encode(this.printtable.nativeElement.innerHTML);
		const today = new Date();
		const data = {
			content: encoded,
			filename: 'recent-payments.pdf',
			landscape: true,
			title: 'Recent Payments',
			subtitle: 'Created ' + today.toLocaleString()
		};
		this.printService.pdf(data).subscribe((result: any) => {
			this.globalSearchService.downloadPdf(result.content, data.filename);
			this.exporting = false;
		});
	}

	exportXls() {
		this.exporting = true;
		const encoded: string = this.globalSearchService.base64encode(this.printtable.nativeElement.innerHTML);
		const today = new Date();
		const data = {
			content: encoded,
			filename: 'recent-payments.xlsx',
			title: 'Recent Payments',
			subtitle: 'Created ' + today.toLocaleString()
		};
		this.printService.xls(data).subscribe((result: any) => {
			this.globalSearchService.downloadXls(result.content, data.filename);
			this.exporting = false;
		});
	}

	getAmount(v: any): number {
		return this.parseNumber(v.amount);
	}

	private parseNumber(value: any): number {
		if (value == null || value === '') {
			return 0;
		}
		if (typeof value === 'number') {
			return value;
		}
		const cleaned = value.toString().replace(/[^\d.-]/g, '');
		const parsed = parseFloat(cleaned);
		return isNaN(parsed) ? 0 : parsed;
	}

}
